export abstract class Utils {
  static Greeting(showIcon: boolean): string {
    let date = new Date();
    let result = "";
    if (date.getHours() >= 1 && date.getHours() < 12) {
      result = "Good morning" + (showIcon ? "🌄" : "");
    } else if (date.getHours() >= 12 && date.getHours() <= 17) {
      result = "Good afternoon" + (showIcon ? "☀️" : "");
    } else {
      result = "Good evening" + (showIcon ? "🌙" : "");
    }

    return result;
  }
  static ShowPopup(
    url: string,
    winName: string,
    w: number,
    h: number,
    scroll: string
  ) {
    let leftPosition = screen.width ? (screen.width - w) / 2 : 0;
    let topPosition = screen.height ? (screen.height - h) / 2 : 0;
    let settings = `height=${h},width=${w},top=${topPosition},left=${leftPosition},scrollbars=${scroll},resizable`;
    return window.open(url, winName, settings);
  }

  static PhoneNumberFormated(phone: string): string {
    if (phone === null || phone === "") {
      return "-";
    }
    var x = phone.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x === null) {
      return "-";
    }
    return !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  }
}
